import './styles/title.css'

export default function Title({children}) {
  return (
    <h1>
      {children}
    </h1>
  )
}
